module.exports = "/_next/static/images/1e3fd028995cd1e42da6d2b0c1ffaceb-pj-person-making-card-purchase@3x.jpg";